import {parseNumber, isInteger} from '../../../lib/utils'

export default {
  data() {
    return {
      ticketCountStepNumber: 1,
      dateSelectionStepNumber: 2,
      personalDetailsStepNumber: 3,
      pricingSummaryStepNumber: 4,
    }
  },
  computed: {
    disabled() {
      return this.termsAgreed !== 'yes'
    },
    ticketsNotSet() {
      const count = parseNumber(this.quantity)
      return this.disabled || !isInteger(count, 1)
        || this.moreThanQuantityLimit
    },
    dateNotSelected() {
      return this.ticketsNotSet || !this.selectedDate
    },
    showTimeslotInputs() {
      return !this.dateNotSelected
    },
    showTimeslotInfo() {
      return this.showTimeslotInputs && !_.isEmpty(this.retrievedTimeslots)
    },
    disabledPersonalDetails() {
      return this.ticketsNotSet
    },
    showMiniCart() {
      return this.showTimeslotInputs && this.totalParticipantsSlotted === this.totalQuantity
    },
    notAllParticipantsSlotted() {
      return this.totalParticipantsSlotted < this.totalQuantity
    },
    cartNotReady() {
      return this.isPersonalDetailsInvalid ||
        !this.showMiniCart ||
        this.isAnyProcessing() ||
        this.notAllParticipantsSlotted
    },
  }
}
